export const TASK_TRACKER_COLUMN_SORT_POSITION_VALUE = 'position'

export const TASK_TRACKER_COLUMN_SORT_POSITION_LABEL = 'Порядок на доске'

export const TASK_TRACKER_COLUMN_SORT_INTRA_COLUMN_REORDER_MESSAGE = `Для сортировки внутри столбца включите сортировку «${TASK_TRACKER_COLUMN_SORT_POSITION_LABEL}»`

export const TASK_TRACKER_COLUMN_SORT_SYSTEM_OPTIONS = [
  { value: TASK_TRACKER_COLUMN_SORT_POSITION_VALUE, label: TASK_TRACKER_COLUMN_SORT_POSITION_LABEL },
  { value: 'title', label: 'Название' },
  { value: 'deadline', label: 'Дедлайн' },
  { value: 'performers', label: 'Исполнители' },
  { value: 'is_completed', label: 'Выполнена' },
  { value: 'creator', label: 'Автор' },
] as const

export type TaskTrackerColumnSortSystemField =
  (typeof TASK_TRACKER_COLUMN_SORT_SYSTEM_OPTIONS)[number]['value']
